module.exports = __webpack_public_path__ + "img/9-dataset.ffb411c8.png";